import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const tiers = [{
  name: 'Plus',
  price: '$199',
  unit: '/ month'
}, {
  name: 'Pro',
  price: '$499',
  unit: '/ month'
}, {
  name: 'Enterprise',
  price: '$999',
  unit: '/ month'
}];
const enterprise = ['Institutional deployments', 'Custom workflows', 'Data and system integrations', 'Enterprise venture-intelligence infrastructure', 'Strategic programs similar to the Sony engagement'];
const expansion = ['Additional workspaces', 'More premium analyses', 'Portfolio monitoring', 'LP intelligence and reporting', 'Enterprise data integrations', 'Organization-level intelligence models'];
export function BusinessModelSlide() {
  return <Slide index={10} data-id="element-56" data-mp="169lz1ooguxxh">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-57" data-mp="16ax3lqpqk9pn">
        <div className="max-w-[62%]" data-id="element-58" data-mp="11b0z7qd4mg9k">
          <Eyebrow data-id="element-59" data-mp="11c3oxuypqcnw">Business model</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-60" data-mp="118y0mhxwret8">
            A recurring software model with a path to high-value enterprise
            contracts.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-61" data-mp="1y84pqppdqriq">
          Workspace subscriptions seed the account; institutional deployments
          carry the contract value.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-[52%_1fr] gap-[3vw]" data-id="element-62" data-mp="279uipzywtyim">
        <div data-id="element-63" data-mp="2c85sybt4ab1d">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#3B8CFF]" data-id="element-64" data-mp="2c6ky0l2w4q2z">
            DiligenceGPT™ workspaces
          </span>
          <div className="mt-[2.2vh] grid grid-cols-3 gap-[1.4vw]" data-id="element-65" data-mp="2lx7bo9r1r6j1">
            {tiers.map((tier, i) => <Reveal key={tier.name} delay={0.07 * i} className="border border-white/10 bg-white/[0.03] p-[1.4vw]" data-id="element-66" data-mp="2qw0khove29cv" data-mpi={i}>
                <p className="text-[clamp(9px,0.94vw,20px)] uppercase tracking-[0.2em] text-[#8B95A8]" data-id="element-67" data-mp="2zwygpkzl5ckw">
                  {tier.name}
                </p>
                <p className="mt-[1.6vh] text-[clamp(20px,2.4vw,50px)] leading-none text-[#F4F7FC]" style={{
              fontFamily: 'var(--font-serif)'
            }} data-id="element-68" data-mp="zvihrain6lpw">
                  {tier.price}
                </p>
                <p className="mt-[0.9vh] text-[clamp(8px,0.82vw,17px)] text-[#7C8699]" data-id="element-69" data-mp="14tsdpnc6xqck">
                  {tier.unit}
                </p>
              </Reveal>)}
          </div>

          <Reveal delay={0.3} className="mt-[3vh] border-t border-white/12 pt-[2vh]" data-id="element-70" data-mp="1jkj5wwhp2rg7">
            <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-71" data-mp="1elpoiszaegar">
              Expansion within an account
            </span>
            <Caption className="mt-[1.2vh]" data-id="element-72" data-mp="1nll5xfjfr7j8">{expansion.join(' · ')}</Caption>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="border-l border-white/10 pl-[2.4vw]" data-id="element-73" data-mp="3ub9j4aw1vhve">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#D8A55A]" data-id="element-74" data-mp="3pcpw075q001g">
            Enterprise &amp; strategic engagements
          </span>
          <ul className="mt-[2.2vh] space-y-[1.6vh]" data-id="element-75" data-mp="29sfif2oth5g7">
            {enterprise.map(item => <li key={item} className="text-[clamp(10.5px,1.14vw,24px)] leading-snug text-[#DCE3EE]" data-id="element-76" data-mp="1w1ah7w5sw53r">
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </Slide>;
}